import { render, staticRenderFns } from "./B2CSalesOrderDetails.vue?vue&type=template&id=eeae1b74"
import script from "./B2CSalesOrderDetails.vue?vue&type=script&lang=js"
export * from "./B2CSalesOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./B2CSalesOrderDetails.vue?vue&type=style&index=0&id=eeae1b74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports